import React from 'react'
import Select, { components } from 'react-select'
import { getAvailableTagsList } from '../../store/actions/tags'
import Loading from 'react-loading'
import { connect } from 'react-redux'

class TagSelector extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            options: undefined,
        }
    }

    componentDidMount() {
        this.props.getAvailableTagsList()
    }

    componentDidUpdate(prevProps) {
        if (this.props.tags !== prevProps.tags || this.props.selectedTags !== prevProps.selectedTags) {


            const options = this.props.tags.map((tag) => ({
                label: tag.name,
                value: tag.name,
                selected:
                    this.props.selectedTags &&
                    this.props.selectedTags.includes(tag.name),
            }))

            this.setState({
                options: options,
            })
        }
    }

    onSelectionChange = (selection) => {
        this.props.onSelectionChange(selection)
    }

    render() {
        if (!this.state.options || !this.props.selectedTags || !this.props.tags) return <Loading />

        const Menu = (props) => {
            const optionSelectedLength = props.getValue().length || 0
            return (
                <components.Menu {...props}>
                    {optionSelectedLength < this.props.limit ? (
                        props.children
                    ) : (
                        <div style={{ margin: 15 }}>
                            Maximum of {this.props.limit} Tags reached.
                        </div>
                    )}
                </components.Menu>
            )
        }

        const selectedOptions = this.state.options.filter((o) => o.selected)

        return (
            <>
                <Select
                    isMulti
                    placeholder="Select your tags..."
                    components={{ Menu }}
                    value={selectedOptions}
                    options={this.state.options}
                    onChange={this.onSelectionChange}
                    menuPlacement="top"
                    theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: { ...theme.colors, primary: '#eee' },
                    })}
                />
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    tags: state.tags.availableTagsList,
})

export default connect(mapStateToProps, { getAvailableTagsList })(TagSelector)
